import React, { FC } from 'react';
import { Button, Divider, Icon } from 'semantic-ui-react';

import { Align, Size } from '@src/types';
import { BasicDialogContainer } from '@src/views/components/modals/BasicDialogContainer';
import { StyledContainer, Flexbox, FlexItem } from '@src/views/containers';

import pdf1yr from '@src/_assets/pdf/Corval Waypoint 1-Year Sample Plan.pdf';
import pdf2yr from '@src/_assets/pdf/Corval Waypoint 2-Year Sample Plan.pdf';
import pdf3yr from '@src/_assets/pdf/Corval Waypoint 3-Year Sample Plan.pdf';

interface PdfItem {
    projectName: string;
    label:       string;
    url:         string;
}

// Hardcoded mapping: Waypoint Biopharma project name → PDF
const PDF_FILES: PdfItem[] = [
    { projectName: 'One Year to Launch',    label: 'Corval Waypoint 1-Year Sample Plan', url: pdf1yr },
    { projectName: 'Two Years to Launch',   label: 'Corval Waypoint 2-Year Sample Plan', url: pdf2yr },
    { projectName: 'Three Years to Launch', label: 'Corval Waypoint 3-Year Sample Plan', url: pdf3yr },
];

const getMatchingPdf = ( projectName: string | null ): PdfItem | null => {
    if ( !projectName ) return null;
    return PDF_FILES.find( p => p.projectName.toLowerCase() === projectName.toLowerCase() ) ?? null;
};

interface Props {
    projectName?: string | null;
    onClose?:     () => void;
}

const DownloadPdfDialog: FC<Props> = ({ projectName, onClose }) => {

    const matchedPdf = getMatchingPdf( projectName );
    const pdfsToShow = matchedPdf ? [ matchedPdf ] : PDF_FILES;

    const handleDownload = ( url: string, label: string ) => {
        const a    = document.createElement( 'a' );
        a.href     = url;
        a.download = label + '.pdf';
        a.target   = '_blank';
        a.rel      = 'noopener noreferrer';
        a.click();
    };

    return (
        <BasicDialogContainer
            title="Download PDF"
            roundedTop
            contentPadding={ [ Size.MD, Size.MD, Size.LG, Size.MD ] }
            onClose={ onClose }
        >
            <StyledContainer padding={ [ Size.SM, 0 ] }>
                { pdfsToShow.map( ( pdf, i ) => (
                    <React.Fragment key={ pdf.projectName }>
                        { i > 0 && <Divider /> }
                        <Flexbox>
                            <FlexItem grow>
                                <span style={ { fontWeight: 500 } }>
                                    <Icon name="file pdf" color="red" />
                                    { pdf.label }
                                </span>
                            </FlexItem>
                            <FlexItem>
                                <Button
                                    type="button"
                                    icon="download"
                                    content="Download"
                                    basic
                                    color="purple"
                                    size="small"
                                    onClick={ () => handleDownload( pdf.url, pdf.label ) }
                                />
                            </FlexItem>
                        </Flexbox>
                    </React.Fragment>
                ) ) }
            </StyledContainer>

            <Divider />

            <StyledContainer textAlign={ Align.RIGHT }>
                <Button
                    type="button"
                    basic
                    content="Close"
                    onClick={ onClose }
                />
            </StyledContainer>
        </BasicDialogContainer>
    );
};

export { DownloadPdfDialog };
